export const buildContractHomeViewItems = ($t) => [
  { value: "board", label: $t("ncrm.contracts.home.views.board") },
  { value: "table", label: $t("ncrm.contracts.home.views.table") },
  { value: "payments", label: $t("ncrm.contracts.home.views.payments") },
];

export const buildContractTableHeaders = ($t) => [
  { title: $t("ncrm.contracts.columns.contract"), key: "contract_number", minWidth: "140px" },
  { title: $t("ncrm.contracts.columns.company"), key: "company_name" },
  { title: $t("ncrm.contracts.columns.person"), key: "person_name" },
  { title: $t("ncrm.contracts.columns.owner"), key: "owner_name" },
  { title: $t("ncrm.contracts.columns.status"), key: "status", sortable: false },
  { title: $t("ncrm.contracts.columns.amount"), key: "total_amount", align: "end" },
  { title: $t("ncrm.contracts.columns.contractDate"), key: "contract_date" },
  { title: $t("ncrm.contracts.columns.onboardings"), key: "onboarding_count", sortable: false, align: "center" },
  { title: $t("ncrm.contracts.columns.overduePayments"), key: "overdue_payment_count", sortable: false, align: "center" },
  { title: $t("ncrm.contracts.columns.updatedAt"), key: "updated_at" },
  { title: "", key: "row_nav", sortable: false, width: "48px" },
];

export const buildContractPaymentHeaders = ($t) => [
  { title: $t("ncrm.contracts.home.payments.columns.paidAt"), key: "paid_at", minWidth: "150px", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.amount"), key: "amount_paid", align: "end", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.contract"), key: "contract_number", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.company"), key: "company_name", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.owner"), key: "owner_name", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.method"), key: "payment_method", sortable: false },
  { title: $t("ncrm.contracts.home.payments.columns.recordedBy"), key: "recorded_by_name", sortable: false },
  { title: "", key: "row_nav", sortable: false, width: "48px" },
];

export const buildContractStatusItems = ({ $t, statusLabel }) => [
  { label: $t("ncrm.contracts.filters.allStatuses"), value: "" },
  { label: statusLabel("draft"), value: "draft" },
  { label: statusLabel("active"), value: "active" },
  { label: statusLabel("fulfilled"), value: "fulfilled" },
  { label: statusLabel("expired"), value: "expired" },
  { label: statusLabel("terminated"), value: "terminated" },
  { label: statusLabel("canceled"), value: "canceled" },
];

export const buildBoardStatusGroupItems = ($t) => [
  { value: "active_work", label: $t("ncrm.contracts.home.boardScopes.activeWork") },
  { value: "all", label: $t("ncrm.contracts.home.boardScopes.allStatuses") },
  { value: "closed_archive", label: $t("ncrm.contracts.home.boardScopes.closedArchive") },
];

export const buildContractPaymentSubViewItems = ($t) => [
  { value: "due", label: $t("ncrm.contracts.home.payments.due"), icon: "mdi-calendar-clock-outline" },
  { value: "paid", label: $t("ncrm.contracts.home.payments.paid"), icon: "mdi-cash-check" },
];
